import { render, staticRenderFns } from "./KpiStrip.vue?vue&type=template&id=3d734fc4"
import script from "./KpiStrip.vue?vue&type=script&lang=js"
export * from "./KpiStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports